// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:09624899-b8d6-45af-b0d7-0031fafea9ee",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_ZfDvXdgqJ",
    "aws_user_pools_web_client_id": "hhiqldg44pf40lk2q1dhu0tij",
    "oauth": {},
    "aws_content_delivery_bucket": "admin-20190622193319-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://dh5gh9s5u8zm6.cloudfront.net"
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js